// Egy egyszerű példányosítás, hogy ne kelljen minden projectben külön-külön ezt megcsinálni.

import ClientRouter from './ClientRouter'

const router = new ClientRouter()

// eslint-disable-next-line custom/export-default-name -- Nem felelünk itt meg a fájlnévnek.
export default router
